import HOST_API from 'constants/HOST_API';
import useFetch from './useFetch';


import React from 'react';
import Recoil from 'recoil';
import CryptoJS from 'crypto-js';
import * as AppStore from 'stores/AppStore';

export default function useSimulationMeal(props) {
  const onRequest = useFetch(HOST_API, 'V100/simulation/meal');
  const acces_token = Recoil.useRecoilValue(AppStore.communication.access_token);

  const requestSimulationMeal = React.useCallback((parameters, callback) => {
    const onReceive = (res) => {
      if (+res.res_code === 200) {
        callback && callback(true, res.data, parameters);
      } else {
        callback && callback(false, { message: res?.res_msg });
      }
    };
    const onCatch = (err) => {
      callback && callback(false, { message: '서버에 연결할 수 없습니다.' }, parameters);
    };
    const onExpire = (abort) => {
      abort('Timeout');
      callback && callback(false, { message: '서버가 응답하지 않습니다.' }, parameters);
      return true;
    };

    onRequest({
      parameters,
      timeout: 6000,
      events: {
        onReceive,
        onExpire,
        onCatch,
      },
    }, {
      access_token: acces_token,
    });
  }, [onRequest, acces_token]);

  const onSimulationMeal = React.useCallback((parameters, callback) => (data) => {
    requestSimulationMeal({ ...data, ...parameters }, callback);
  }, [requestSimulationMeal]);

  return {
    requestSimulationMeal,
    onSimulationMeal,
  };
}
